import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { NotificationsService } from 'angular2-notifications';
import { FeeColumnFilterPanelService, PlayerAdjustmentService } from '../../../../services';
import { StorageUtil } from '../../../../store';

@Component({
  selector: 'app-player-discount',
  templateUrl: './player-discount.component.html',
  styleUrls: ['./player-discount.component.css']
})
export class PlayerDiscountComponent implements OnInit {
  public discountTypes: any[];
  public playerDiscountForm: FormGroup;
  public validationMessages = {};

  @Input() programId;
  @Input() ClubUserProgramFeeID: string;
  @Input() ClubProgramFeeID: string;
  @Input() UserID: string;

  constructor(private fb: FormBuilder,
    private router: Router,
    private activeRoute: ActivatedRoute,
    private notificationsService: NotificationsService,
    private feeColumnFilterPanelService: FeeColumnFilterPanelService,
    private playerAdjustmentService: PlayerAdjustmentService
  ) {
    this.discountTypes = [
      { 'key': 1, 'value': 'Employee' },
      { 'key': 2, 'value': 'Sibling / Family' },
      { 'key': 3, 'value': 'Travel / Entertainment' },
      { 'key': 4, 'value': 'Proration' },
      { 'key': 5, 'value': 'Volunteer Work' },
      { 'key': 6, 'value': 'Other' },
    ];
    this.validationMessages = {
      'Required': 'This field is required.'
    };
  }

  ngOnInit() {
    this.initForm();
  }

  initForm() {
    this.playerDiscountForm = this.fb.group({
      AmountDiscounted: ['', [Validators.required]],
      DiscountType: ['', [Validators.required]],
    });
  }

  isAmountDiscountedValid() {
    return this.playerDiscountForm.get('AmountDiscounted').errors
      && (this.playerDiscountForm.get('AmountDiscounted').touched
        || this.playerDiscountForm.get('AmountDiscounted').dirty);
  }

  isDiscountTypeValid() {
    return this.playerDiscountForm.get('DiscountType').errors
      && (this.playerDiscountForm.get('DiscountType').touched
        || this.playerDiscountForm.get('DiscountType').dirty);
  }

  validateUi() {
    Object.keys(this.playerDiscountForm.controls).forEach(field => {
      const control = this.playerDiscountForm.get(field);
      control.markAsTouched({ onlySelf: true });
    });
  }

  onSubmit(event, formStatus) {
    event.stopPropagation();
    if (formStatus === 'VALID') {
      console.log('UserID - ', this.UserID);
      const obj = {
        ClubUserProgramFeeID: Number(this.ClubUserProgramFeeID),
        ClubProgramFeeAdjustmentTypeID: 0,
        ClubUserProgramPlayerDiscountTypeID: Number(this.playerDiscountForm.value.DiscountType),
        Amount: Number(this.playerDiscountForm.value.AmountDiscounted),
        UserId: this.UserID,
        ClubProgramID: this.programId, // Get ClubProgramID from URL
        AddedBy: StorageUtil.userID
      };
      event.target.innerHTML = 'Saving <i class="fa fa-spinner fa-spin push-5-r"></i>';
      event.target.disabled = true;
      this.playerAdjustmentService.savePlayerDiscount(obj).subscribe((data: any) => {
        event.target.innerHTML = 'Save';
        event.target.disabled = false;
        this.clearFormData();
        this.closeSideOverlay();
        this.alertMessage('success', data.result);
      }, error => {
        this.alertMessage('error', error.statusText);
      });
    } else {
      this.validateUi();
    }
  }

  clearFormData() {
    this.playerDiscountForm.reset();
  }

  onReset(event) {
    event.stopPropagation();
    this.clearFormData();
    this.closeSideOverlay();
  }

  closeSideOverlay() {
    this.feeColumnFilterPanelService.setToggleFilterColumnsPanel(false);
  }

  alertMessage(status, message) {
    const toast = this.notificationsService.success(status, message, {
      timeOut: 3000,
      showProgressBar: true,
      pauseOnHover: false,
      clickToClose: false
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/member-billing-info/player-discount/player-discount.component.ts